/* Autogenerated file. Do not edit manually. */
/* eslint-disable */
import { Contract, utils } from 'ethers';
const _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'asset',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'reward',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'emission',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'distributionEnd',
                type: 'uint256',
            },
        ],
        name: 'AssetConfigUpdated',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'asset',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'reward',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'index',
                type: 'uint256',
            },
        ],
        name: 'AssetIndexUpdated',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'user',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'claimer',
                type: 'address',
            },
        ],
        name: 'ClaimerSet',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'reward',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'rewardOracle',
                type: 'address',
            },
        ],
        name: 'RewardOracleUpdated',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'user',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'reward',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'amount',
                type: 'uint256',
            },
        ],
        name: 'RewardsAccrued',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'user',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'reward',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'to',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'address',
                name: 'claimer',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'amount',
                type: 'uint256',
            },
        ],
        name: 'RewardsClaimed',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'reward',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'transferStrategy',
                type: 'address',
            },
        ],
        name: 'TransferStrategyInstalled',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'user',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'asset',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'reward',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'index',
                type: 'uint256',
            },
        ],
        name: 'UserIndexUpdated',
        type: 'event',
    },
    {
        inputs: [],
        name: 'PRECISION',
        outputs: [
            {
                internalType: 'uint8',
                name: '',
                type: 'uint8',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address[]',
                name: 'assets',
                type: 'address[]',
            },
            {
                internalType: 'address',
                name: 'to',
                type: 'address',
            },
        ],
        name: 'claimAllRewards',
        outputs: [
            {
                internalType: 'address[]',
                name: 'rewardsList',
                type: 'address[]',
            },
            {
                internalType: 'uint256[]',
                name: 'claimedAmounts',
                type: 'uint256[]',
            },
        ],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address[]',
                name: 'assets',
                type: 'address[]',
            },
            {
                internalType: 'address',
                name: 'user',
                type: 'address',
            },
            {
                internalType: 'address',
                name: 'to',
                type: 'address',
            },
        ],
        name: 'claimAllRewardsOnBehalf',
        outputs: [
            {
                internalType: 'address[]',
                name: 'rewardsList',
                type: 'address[]',
            },
            {
                internalType: 'uint256[]',
                name: 'claimedAmounts',
                type: 'uint256[]',
            },
        ],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address[]',
                name: 'assets',
                type: 'address[]',
            },
        ],
        name: 'claimAllRewardsToSelf',
        outputs: [
            {
                internalType: 'address[]',
                name: 'rewardsList',
                type: 'address[]',
            },
            {
                internalType: 'uint256[]',
                name: 'claimedAmounts',
                type: 'uint256[]',
            },
        ],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address[]',
                name: 'assets',
                type: 'address[]',
            },
            {
                internalType: 'uint256',
                name: 'amount',
                type: 'uint256',
            },
            {
                internalType: 'address',
                name: 'to',
                type: 'address',
            },
            {
                internalType: 'address',
                name: 'reward',
                type: 'address',
            },
        ],
        name: 'claimRewards',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address[]',
                name: 'assets',
                type: 'address[]',
            },
            {
                internalType: 'uint256',
                name: 'amount',
                type: 'uint256',
            },
            {
                internalType: 'address',
                name: 'user',
                type: 'address',
            },
            {
                internalType: 'address',
                name: 'to',
                type: 'address',
            },
            {
                internalType: 'address',
                name: 'reward',
                type: 'address',
            },
        ],
        name: 'claimRewardsOnBehalf',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address[]',
                name: 'assets',
                type: 'address[]',
            },
            {
                internalType: 'uint256',
                name: 'amount',
                type: 'uint256',
            },
            {
                internalType: 'address',
                name: 'reward',
                type: 'address',
            },
        ],
        name: 'claimRewardsToSelf',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: 'uint104',
                        name: 'emissionPerSecond',
                        type: 'uint104',
                    },
                    {
                        internalType: 'uint256',
                        name: 'totalSupply',
                        type: 'uint256',
                    },
                    {
                        internalType: 'uint40',
                        name: 'distributionEnd',
                        type: 'uint40',
                    },
                    {
                        internalType: 'address',
                        name: 'asset',
                        type: 'address',
                    },
                    {
                        internalType: 'address',
                        name: 'reward',
                        type: 'address',
                    },
                    {
                        internalType: 'contract ITransferStrategy',
                        name: 'transferStrategy',
                        type: 'address',
                    },
                    {
                        internalType: 'bytes',
                        name: 'transferStrategyParams',
                        type: 'bytes',
                    },
                    {
                        internalType: 'contract IEACAggregatorProxy',
                        name: 'rewardOracle',
                        type: 'address',
                    },
                ],
                internalType: 'struct DistributionTypesV2.RewardsConfigInput[]',
                name: 'config',
                type: 'tuple[]',
            },
        ],
        name: 'configureAssets',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address[]',
                name: 'assets',
                type: 'address[]',
            },
            {
                internalType: 'address',
                name: 'user',
                type: 'address',
            },
        ],
        name: 'getAllUserRewardsBalance',
        outputs: [
            {
                internalType: 'address[]',
                name: '',
                type: 'address[]',
            },
            {
                internalType: 'uint256[]',
                name: '',
                type: 'uint256[]',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'user',
                type: 'address',
            },
        ],
        name: 'getClaimer',
        outputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'asset',
                type: 'address',
            },
            {
                internalType: 'address',
                name: 'reward',
                type: 'address',
            },
        ],
        name: 'getDistributionEnd',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'reward',
                type: 'address',
            },
        ],
        name: 'getRewardOracle',
        outputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'asset',
                type: 'address',
            },
        ],
        name: 'getRewardsByAsset',
        outputs: [
            {
                internalType: 'address[]',
                name: '',
                type: 'address[]',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'asset',
                type: 'address',
            },
            {
                internalType: 'address',
                name: 'reward',
                type: 'address',
            },
        ],
        name: 'getRewardsData',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'getRewardsList',
        outputs: [
            {
                internalType: 'address[]',
                name: '',
                type: 'address[]',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'reward',
                type: 'address',
            },
        ],
        name: 'getTransferStrategy',
        outputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'user',
                type: 'address',
            },
            {
                internalType: 'address',
                name: 'asset',
                type: 'address',
            },
            {
                internalType: 'address',
                name: 'reward',
                type: 'address',
            },
        ],
        name: 'getUserAssetData',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address[]',
                name: 'assets',
                type: 'address[]',
            },
            {
                internalType: 'address',
                name: 'user',
                type: 'address',
            },
            {
                internalType: 'address',
                name: 'reward',
                type: 'address',
            },
        ],
        name: 'getUserRewardsBalance',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'user',
                type: 'address',
            },
            {
                internalType: 'address',
                name: 'reward',
                type: 'address',
            },
        ],
        name: 'getUserUnclaimedRewardsFromStorage',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'user',
                type: 'address',
            },
            {
                internalType: 'uint256',
                name: 'userBalance',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: 'totalSupply',
                type: 'uint256',
            },
        ],
        name: 'handleAction',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'user',
                type: 'address',
            },
            {
                internalType: 'address',
                name: 'claimer',
                type: 'address',
            },
        ],
        name: 'setClaimer',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'asset',
                type: 'address',
            },
            {
                internalType: 'address',
                name: 'reward',
                type: 'address',
            },
            {
                internalType: 'uint40',
                name: 'distributionEnd',
                type: 'uint40',
            },
        ],
        name: 'setDistributionEnd',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'reward',
                type: 'address',
            },
            {
                internalType: 'contract IEACAggregatorProxy',
                name: 'rewardOracle',
                type: 'address',
            },
        ],
        name: 'setRewardOracle',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'reward',
                type: 'address',
            },
            {
                internalType: 'contract ITransferStrategy',
                name: 'transferStrategy',
                type: 'address',
            },
            {
                internalType: 'bytes',
                name: 'params',
                type: 'bytes',
            },
        ],
        name: 'setTransferStrategy',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
];
export class IAaveIncentivesControllerV2__factory {
    static createInterface() {
        return new utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi, signerOrProvider);
    }
}
IAaveIncentivesControllerV2__factory.abi = _abi;
//# sourceMappingURL=IAaveIncentivesControllerV2__factory.js.map